module.exports = __webpack_public_path__ + "img/symbol_10.73cd4555.png";